module.exports = __webpack_public_path__ + "static/img/pro3.3dcee9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pro3.png
// module id = EIeA
// module chunks = 0